export default __webpack_public_path__ + "3726d3a11a1b256beae6afba60cf7b26.png";